import React from 'react';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Corey Noble</h1>
        <h2>Web Application Developer</h2>
      </header>
    </div>
  );
}

export default App;
